import React from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck,  } from '@fortawesome/free-solid-svg-icons';
import './SubmissionSuccessful.scss';

const SubmissionSuccessful = ({showSubmitSuccess, onClose}) => {
    return (
        <Modal className='submission-success' show={showSubmitSuccess} onHide={onClose}>
            <Modal.Header closeButton>
                <FontAwesomeIcon className='icon' icon={faCheck} />
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col>
                            <div>
                                
                                <h4 className='title'>Touchdown! Thank you for adding your Venue into the Playbook!</h4>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            
        </Modal>
    );
};

export default SubmissionSuccessful;